import styled from 'styled-components';

export const Container = styled.div`
  padding-left: 250px;
`;

export const ContentContainer = styled.main`
  padding: 1rem;
  display: flex;
  gap: 2rem;
  max-width: 1100px;
  margin: 0 auto;
`;

export const SurveyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  flex-shrink: 0;
  max-width: 720px;
  width: 100%;
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const SubmitButton = styled.button`
  background-color: #000;
  color: #f2f2f2;
  border-radius: 0.25rem;
  font-size: 1rem;
  font-weight: 500;
  padding: 0.5rem 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: 0.1s all;

  &:hover {
    transform: scale(0.98);
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 90vh;
`;